import { LngLatBoundsLike } from 'maplibre-gl';
import {
  EntityItem,
  IGeocoderResult,
  MapView,
  Position,
  ResultType,
} from '@/types/geocode';

export interface Coordinates {
  coords: {
    latitude: number;
    longitude: number;
  };
}

const getBboxFromMapView = (mapView: MapView): LngLatBoundsLike => {
  const { south, west, north, east } = mapView;
  return [west, south, east, north] as LngLatBoundsLike;
};

const getCoordinatesFromPosition = (position: Position): number[] => {
  const { lat, lng } = position;
  return [lng, lat];
};

export const getUserCurrentLocation = (
  successCallback: (lat: number, lng: number) => void,
  errorCallback: () => void,
) => {
  const geoOptions = {
    timeout: 10 * 1000,
    maximumAge: 60 * 1000,
  };

  navigator.geolocation.getCurrentPosition(
    (position: Coordinates) => {
      successCallback(position.coords.latitude, position.coords.longitude);
    },
    errorCallback,
    geoOptions,
  );
};

export const DEFAULT_ZOOM = 11;

export const getZoomLevel = (location: EntityItem) => {
  switch (location?.resultType) {
    case ResultType.Place:
    case ResultType.Locality:
    case ResultType.AdministrativeArea:
    case ResultType.AddressBlock:
      return 16;
    default:
      return DEFAULT_ZOOM;
  }
};

export const extractGeocoderLocation: (
  location: EntityItem,
) => IGeocoderResult = (location: EntityItem) => {
  const bbox = location.mapView && getBboxFromMapView(location.mapView);
  const address1 = location?.address.street;
  const title = location?.title;
  const place = location?.address.label;
  let nameLine1 = title;
  let nameLine2 = [place, address1].filter(Boolean).join(', ');
  if (!nameLine1 || nameLine1 === nameLine2) {
    nameLine1 = nameLine2;
    nameLine2 = '';
  }
  const name = [nameLine1, nameLine2].filter(Boolean).join(', ');
  const zoom = getZoomLevel(location);
  return {
    ...location,
    center: getCoordinatesFromPosition(location?.position),
    nameLine1,
    nameLine2,
    name,
    bbox,
    zoom,
  };
};
